import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function BioLiteGoldStandard() {
  return (
    <div className="art-page">
      <SEO
        title="Gold Standard PoA Monitoring — BioLite Cookstoves (2023 – Ongoing)"
        description="Since 2023, CIRCODU has conducted Gold Standard monitoring for BioLite cookstoves in Uganda, performing quarterly Water Boiling Tests to verify thermal efficiency and support carbon credit generation."
        keywords="Gold Standard, BioLite, carbon monitoring, Water Boiling Test, thermal efficiency, cookstove, carbon credits, clean energy, Uganda, carbon finance, emissions reduction, sustainable energy, cookstove monitoring, carbon project development, independent monitoring organization, carbon credit verification, CIRCODU, Gold Standard monitoring Uganda, BioLite cookstoves Uganda, carbon monitoring Uganda, Water Boiling Test Uganda, thermal efficiency testing Uganda, cookstove carbon credits Uganda"
        url="/Gold-Standard-PoA-Monitoring-BioLite-Cookstoves"
        datePublished="2023-01-20"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Gold Standard PoA Monitoring — BioLite Cookstoves
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              January 20, 2026
            </div>
            <h1 className="art-title">
              Gold Standard PoA Monitoring — BioLite Cookstoves (2023 – Ongoing)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                Since early 2023, CIRCODU has served as{" "}
                <strong>BioLite's</strong> independent monitoring organisation
                in Uganda for its Gold Standard Programme of Activities. BioLite
                is an international clean energy company whose cookstoves
                combine improved combustion efficiency with innovative features
                — including USB charging capability — and whose products are
                distributed across Uganda through carbon-financed programmes.
                CIRCODU's monitoring role centres on verifying the in-field
                thermal performance of BioLite stoves to support the crediting
                cycle under Gold Standard regulations.
              </p>
              <h2 className="art-subheading">
                Methodology and Monitoring Rounds
              </h2>
              <p>
                Each monitoring round follows an established methodology:
                CIRCODU collects or receives a random sample of BioLite stoves
                that have been in use in the field, conducts{" "}
                <strong>Water Boiling Tests (WBTs)</strong> in its accredited
                cookstove laboratory following WBT Version 4.2.3 guidelines,
                calculates thermal efficiency values for the sampled stoves, and
                produces a formal monitoring report.
              </p>
              <p>
                Monitoring rounds have been completed in January 2023, July
                2023, August–September 2023, July 2024, January 2025, and
                January 2026, with the current monitoring cycle ongoing. The
                consistency of this testing schedule across three consecutive
                years reflects CIRCODU's established role as BioLite's trusted
                independent monitoring partner in Uganda, supporting the
                uninterrupted generation of Gold Standard carbon credits for the
                programme.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's laboratory testing and Gold
                Standard monitoring services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
